import React from 'react';
import { LawFirmItemType } from '../searchAutocomplete.types';
import { AutocompleteItem } from '../AutocompleteItem';
import {
  AutocompleteEntityItem,
  AutocompleteEntityItemLabel,
} from '../entities/EntitiesLib';
import { wantToOpenInNewTab } from '../../../../../utils/linkUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { getLawFirmUrl } from '../autocompleteUtils';
import { ReactComponent as LawFirm } from '../../../../../../icons/entities/law-firm.svg';
import { openNewTab } from '../../../../../utils/domUtils';
import { AutocompleteIcon } from '../icon/AutocompleteIcon';

type Props = {
  item: LawFirmItemType;
  label: string;
  selected: boolean;
  hasOffset: boolean;
  onClick: () => void;
};

export class AutocompleteLawFirmItem extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.source = 'autocomplete_result';
  }

  onClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    const { item, onClick } = this.props;
    const lawyerPageUrl = buildUrlWithParameters(getLawFirmUrl(item), {
      source: this.source,
    });
    onClick();
    if (wantToOpenInNewTab(event)) {
      openNewTab(lawyerPageUrl);
    } else {
      window.location.href = lawyerPageUrl;
    }
  };

  source: string;

  render() {
    const { selected, label, hasOffset } = this.props;
    return (
      <AutocompleteItem
        hasOffset={hasOffset}
        isSelected={selected}
        onClick={this.onClick}
        data-test-id="autocomplete-lawfirm-item"
      >
        <AutocompleteEntityItem selected={selected} title={label}>
          <AutocompleteIcon icon={LawFirm} />
          <AutocompleteEntityItemLabel>{label}</AutocompleteEntityItemLabel>
        </AutocompleteEntityItem>
      </AutocompleteItem>
    );
  }
}
